import React from "react";
import "./Navbar.css";
import NewLifeLogo from "../../assets/images/wingss.png";
import CustomButton from "../customButton/CustomButton";
import { Link } from "react-router-dom";
import { FaRegHeart } from "react-icons/fa";
function Navbar() {
  const navbarHeading = [
    { id: 0, name: "Home", path: "/" },
    { id: 1, name: "About Us", path: "/about" },
    { id: 2, name: "Impact", path: "/impact" },
    { id: 2, name: "Goal", path: "/goal" },
    { id: 3, name: "Donate for a Cause", path: "/donateCause" },
    { id: 4, name: "Contribute", path: "/contribute" },
  ];
  return (
    <div className="nav_main_container">
      <div className="life">
        <img src={NewLifeLogo} alt="" />
      </div>
      {/* <div
        style={{ flexDirection: "row", display: "flex", alignItems: "center" }}
      > */}
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          flex: ".5",
          justifyContent: "flex-end",
        }}
      >
        {navbarHeading?.map((item, index) => {
          return (
            <div key={index} className="nav_item">
              <Link
                to={item?.path}
                style={{ textDecoration: "none", color: "#000" }}
              >
                {item?.name}
              </Link>
            </div>
          );
        })}
      </div>
      {/* button */}
      {/* </div> */}
      <div
        style={{
          flex: "0.2",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <CustomButton buttonIcon={<FaRegHeart />} style={{ width: "20px" }} />
      </div>
    </div>
  );
}

export default Navbar;
